import React, { useState } from "react";
import BannerBreadcrumb from "../../Components/BannerBreadcrumb";
import LocationPinIcon from '@mui/icons-material/LocationPin';

const SbiLendingPartner = () => {
    const [formData, setFormData] = useState({
        name: "",
        email: "",
        phone: "",
        message: "",
        type: "Landing Partner"
    });
    const [loading, setLoading] = useState(false);
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState(null);
    const [fieldErrors, setFieldErrors] = useState({});
    const validate = () => {
        const errors = {};
        if (!formData.name.trim() || !/^[a-zA-Z\s]+$/.test(formData.name)) {
            errors.name = "Name should contain only letters and spaces.";
        }
        if (!/^\d{10}$/.test(formData.phone)) {
            errors.phone = "Phone number must be exactly 10 digits.";
        }
        if (!formData.email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(formData.email)) {
            errors.email = "Please enter a valid email address.";
        }
        if (!formData.message || !formData.message.trim()) {
            errors.message = "Message is required.";
        }
        return errors;
    };

    const handleChange = (e) => {
        const { name, value } = e.target;
        if (name === "phone") {
            if (!/^\d*$/.test(value)) return;
        }
        if (name === "name") {
            if (!/^[a-zA-Z\s]*$/.test(value)) return;
        }
        setFormData((prev) => ({
            ...prev,
            [name]: value
        }));
        setFieldErrors((prev) => ({
            ...prev,
            [name]: undefined
        }));
    };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setSuccess(false);
        setError(null);

        const errors = validate();
        setFieldErrors(errors);
        if (Object.keys(errors).length > 0) {
            setLoading(false);
            return;
        }

        setLoading(true);

        try {
            const formBody = new URLSearchParams(formData).toString();
            await fetch("https://script.google.com/macros/s/AKfycbytFPsSA7Ob7jAQVmRXGHReCfkcWZmnCvpOLdSL7Zw3kEIvSn5YoQELdQBZOLJccA0/exec", {
                method: "POST",
                body: formBody,
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
            });
            setSuccess(true);
            setFormData({
                name: "",
                email: "",
                phone: "",
                message: "",
                type: "Landing Partner"
            });
        } catch (err) {
            setError("Failed to submit. Please try again.");
        }

        setLoading(false);
    };
    const uniqueFeatures = [
        {
            title: "1. How long does it take for an education loan from SBI to be approved?",
            content: "It generally takes around 15 to 20 days for SBI to approve an education loan."
        },
        {
            title: "2. Are there any interest rate concessions or reduced interest rates being offered?",
            content: "By enrolling in the SBI Rinn Raksha policy or any other life policy offered by the bank, students can benefit from a reduced interest rate of 0.5%. Additionally, female students are eligible for an extra concession of 0.5%."
        },
        {
            title: "3. Are Accommodation Costs, such as housing or off-campus flats on rent, covered by the SBI education loan abroad?",
            content: "The SBI education loan amount caters to the financial needs related to living and accommodation expenses."
        },
        {
            title: "4. Does SBI charge a fee for early payment on education loans?",
            content: "You can pay off your education loan early without any extra charges after 6 months from when you received the loan."
        }, {
            title: "5. Are there any subsidies offered on educational loans by SBI?",
            content: "The government has introduced two schemes to provide interest rate subsidies – the Dr. Ambedkar Central Sector Scheme and the Central Scheme of Interest Subsidy for education loans."
        }, {
            title: "6. Can SBI offer education loans without requiring collateral?",
            content: "Up to INR 7.5 Lakh education loans are available from SBI without the need for collateral."
        }
    ];

    const [openIndex, setOpenIndex] = useState(null);
    const handleAccordion = idx => {
        setOpenIndex(openIndex === idx ? null : idx);
    };
    return (
        <>
            <BannerBreadcrumb head={"SBI Education Loan"} parades={"Get Free Education Loan Assistance From Credere"} pagename={"SBI Education Loan"} />
            <section className="blog-section">
                <div className="container">
                    <div className="row">
                        <div className="col-md-8 loan-eligibility">
                            <p className="loan-eligibility-des">The State Bank of India (SBI) is the biggest public sector bank in India. It was founded in 1955 and has the highest number of assets, branches, deposits, customers, and staff. SBI plays a vital role in shaping India’s economy. As part of its services, SBI provides education loans to deserving students who want to pursue higher education in India or overseas.</p>
                            <h5 className="about-head">SBI Provides the Global Ed-Vantage Education Loan</h5>
                            <p className="loan-elegibility-des">The Global Ed-Vantage education loan program provides secure loans for Indian students who wish to study abroad. Through this program, students may borrow up to INR 1.5 Cr to finance their overseas education. To obtain an SBI education loan for studying abroad, students must provide collateral worth at least 90% of the total loan amount.
                                <br /><br />
                                For example – If a student wishes to borrow INR 50 Lakh, they must have a collateral value of at least INR 45 Lakh.</p>


                            <h5 className="about-head">Overview of the Global Ed-Vantage Education Loan from SBI</h5>

                            <table className="table table-bordered table-striped customtable mt-4 mb-4">
                                <thead className="table-head">
                                    <tr>
                                        <th>Features</th>
                                        <th>Description	</th>


                                    </tr>

                                </thead>
                                <tbody className="table-body">
                                    <tr>
                                        <td className="">
                                            Rate of interest</td>
                                        <td className="">

                                            10.15%-11.15%(Floating)<br />
                                            (0.5% concession for female appliucants)
                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Loan amount</td>
                                        <td className="">

                                            INR 7.5 Lakh - INR 1.5 Cr

                                        </td>


                                    </tr>
                                    <tr>
                                        <td>Processing Fees</td>
                                        <td>INR 10,000 + GST (Non-refundable)</td>
                                    </tr>
                                    <tr>
                                        <td>Margin Money</td>
                                        <td>INR 7.5 Lakh - INR 20 Lakh - 15%<br />
                                            INR 20 Lakh - 10%</td>
                                    </tr>
                                    <tr>
                                        <td className="">
                                            Property evaluation charges</td>
                                        <td className="">

                                            Approximately INR 7,500
                                            (Note-property evaluation charges are subjects to changes, they may vary depending on one's location)

                                        </td>


                                    </tr>
                                    <tr>
                                        <td className="">
                                            Moratorium period
                                        </td>

                                        <td className="">
                                            Course duration + 6 months</td>

                                    </tr>
                                    <tr>
                                        <td className="">

                                            Repayment tenure
                                        </td>
                                        <td className="">

                                            15 years
                                        </td>


                                    </tr>



                                </tbody>
                            </table>
                            <ol className="subhead-ul">
                                <li>You are given a moratorium period where you don’t have to make any payments towards your education loan.</li>
                                <li>Margin money is the borrower’s contribution to the loan, with the lender covering the remaining amount</li>
                            </ol>
                            <h5 className="about-head">The Eligibility Requirements for the SBI Global Ed-Vantage Education Loan </h5>
                            <h5 className="about-head">Age</h5>
                            <p className="loan-elegibility-des">To apply, the candidate must hold Indian citizenship and be at least 18 years old at the time of applying.</p>
                            <h5 className="about-head">Education Qualification</h5>

                            <p className="loan-elegibility-des">To be eligible, the candidate must have been accepted into a reputable university or institution for a program that will result in the desired degree or diploma.</p>
                        </div>
                        <div className="col-md-4">
                            <div className="blog-right">
<form className="loan-check-form" style={{ padding: "50px" }} onSubmit={handleSubmit}>
                                    <h4 className="" style={{ fontSize: "20px" }}>Contact Now</h4>
                                    {success && <div className="alert alert-success mt-2">Submitted successfully!</div>}
                                    {error && <div className="alert alert-danger mt-2">{error}</div>}
                                    <div className="row">
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Name <span>*</span></label>
                                            <input
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="E.g. Priya Senger"
                                                name="name"
                                                value={formData.name}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.name && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.name}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Email <span>*</span></label>
                                            <input
                                                type="email"
                                                className="form-control finance-input"
                                                placeholder="E.g. priya@doe.com"
                                                name="email"
                                                value={formData.email}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.email && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.email}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Phone<span>*</span></label>
                                            <input
                                                type="tel"
                                                className="form-control finance-input"
                                                placeholder="E.g. 8888880000"
                                                name="phone"
                                                value={formData.phone}
                                                onChange={handleChange}
                                                required
                                                maxLength={10}
                                            />
                                            {fieldErrors.phone && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.phone}</div>
                                            )}
                                        </div>
                                        <div className="col-md-12 finance-head-form">
                                            <label className="form-label finance-label">Message<span>*</span></label>
                                            <textarea
                                                type="text"
                                                className="form-control finance-input"
                                                placeholder="Your message"
                                                name="message"
                                                value={formData.message}
                                                onChange={handleChange}
                                                required
                                            />
                                            {fieldErrors.message && (
                                                <div className="text-danger" style={{ fontSize: "0.9em" }}>{fieldErrors.message}</div>
                                            )}
                                        </div>
                                        <div className="col-12">
                                            <button type="submit" className="loan-btn w-100 mt-3" disabled={loading}>
                                                {loading ? "Submitting..." : "Submit"}
                                            </button>
                                        </div>
                                    </div>
                                </form>
                                <section className="landing-partners mt-5" >
                                    <div className="container">
                                        <div className="row">
                                            <div className="col-md-12">
                                                <h5 className="about-head mb-5 text-center">Our Loan Partners</h5>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/icici-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/auxilo-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/avanse-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/axis-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/bob-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/hdfc-credila-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/union-bank-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/idfc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/increc-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/mpower-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/prodigy-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                            <div className="col-md-4 mb-4">
                                                <img src="/images/sbi-logo.png" alt="Partner Logo" className="img-fluid" />
                                            </div>
                                        </div>
                                    </div>
                                </section>
                            </div>
                        </div>
                        <div className="col-md-12 loan-eligibility">




                            <h5 className="about-head">Academic Performance</h5>
                            <p className="loan-elegibility-des">The lending institution requires the applicant to have a consistently strong academic background and meet their minimum academic requirements. Additionally, the student must also pass any necessary prerequisite exams like GRE, IELTS, or TOEFL.</p>

                            <h5 className="about-head">Co-applicant</h5>
                            <p className="loan-elegibility-des">
                                To apply, the candidate needs to have a co-applicant, who can either be a parent or a legal guardian. The co-applicant should have a steady income and a good credit record. </p>
                            <h5 className="about-head">Course and Country of Study:</h5>
                            <p className="loan-elegibility-des">SBI offers education loans for various types of courses, including regular graduate and post-graduate degrees, diplomas, certificates, and doctorate programs. These loans are available for studying in foreign institutes or universities, regardless of the discipline you choose.
                                <br /><br />
                                At times, the total expenses may encompass the fees for pathway courses that lead to the main course. These expenses can be financed as part of the overall costs. In the case of pilot training courses, the courses must obtain approval from the aviation regulatory authority specific to the country.</p>
                            <h5 className="about-head">Country of study:</h5>
                            <p className="loan-elegibility-des">Education loan from SBI provides financial support for the UK, USA, Australia, Canada, Singapore, Hong Kong, Japan, New Zealand, and Europe [Belgium, Austria, Czech Republic, Estonia, Denmark, Finland, Germany, France, Greece, Italy, Ireland, Netherlands, Poland, Norway, Portugal, Spain, Sweden, Russia, Switzerland, United Kingdom].</p>
                            <h5 className="about-head">Collateral:</h5>
                            <p className="loan-elegibility-des">The assets that SBI accepts as collateral are as follows.</p>
                            <ol className="subhead-ul">
                                <li>Buildings, Residential property</li>
                                <li>Fixed deposits</li>
                            </ol>
                            <h5 className="about-head">What is Rinn Raksha Insurance?</h5>
                            <p className="loan-elegibility-des">Rinn Raksha is an insurance plan provided by the State Bank of India (SBI) exclusively for those who have taken education loans. This plan ensures that if the borrower passes away before completing the loan repayment, their family will be financially protected.
                                <br /><br />
                                SBI provides two insurance options to education loan borrowers under the ‘Rinn Raksha scheme. These options are Group Credit Life Insurance (GCLI) and Term Life Insurance (TLI). GCLI offers coverage for the remaining loan amount if the borrower passes away, while TLI offers coverage for the total assured sum.
                                <br /><br />
                                Moreover, students who decide to take this insurance can enjoy a further 0.5% reduction on the overall interest rate of their education loan.</p>
                            <h5 className="about-head">SBI Education Loan Documents Needed</h5>
                            <p className="loan-elegibility-des">The necessary paperwork for obtaining an SBI education loan for studying abroad varies based on a few factors. These factors include your educational and work background, the financial and credit profile of your co-applicant, and the location of the property or asset that you provide as collateral.</p>
                            <h5 className="about-head">Applicant's Documents</h5>
                            <ol className="subhead-ul">
                                <li>Identity proof: Passport/ PAN/ Voter ID card or government-issued identification document/ Driver’s License.</li>
                                <li>Education Loan Application Form.</li>
                                <li>Address proof: Recent copy of telephone bill/water bill/ electricity bill/ piped gas bill/ Aadhaar card/driving license.</li>
                                <li>Passport.</li>
                                <li>Past academic record.
                                    <ol className="subhead-ul">
                                        <li>10th standard mark sheet</li>
                                        <li>12th standard mark sheet</li>
                                        <li>Undergraduate result (semester-wise)</li>
                                    </ol>
                                </li>

                                <li>Entrance Exam Results (e.g. GRE, GMAT, TOEFL, etc.)</li>
                                <li>Proof of Admission: admission letter (A conditional admission letter is also applicable).</li>
                                <li>Statement of expenses.</li>
                                <li>2 passport-size photographs.</li>
                                <li>Loan A/C Statement of One year (if applicable).</li>
                                <li>Bank Account Statement of the Student (if applicable).</li>
                            </ol>
                            <h5 className="about-head">Co-applicants Documents</h5>
                            <ol className="subhead-ul">
                                <li><b>Identity Proof :</b> PAN/ Driver’s license/ Passport/ Voter ID card or government-issued Identification Document.</li>
                                <li><b>Address :</b> Recent copy of electricity bill/telephone bill /water bill/ piped gas bill or copy of passport/ Aadhaar card/driving license.</li>
                                <li>2 passport-size photographs</li>
                                <li>If you have taken a loan from any other banks or lenders in the past, you will need to provide the loan account statement for 1 year.</li>
                                <li>Legal Documents of the Collateral/ Property documents</li>
                                <li>Bank account statement of the guarantor /co-borrower, for the last 6 months (in case of takeover of education loan).</li>
                            </ol>
                            <h5 className="about-head">Documentation Needed to Verify the Income of a Salaried Co-applicant/Guarantor</h5>
                            <ol className="subhead-ul">
                                <li>Salary slips for the last 3 months</li>
                                <li>Copy of Form 16 of the last 2 years or a copy</li>
                                <li>Bank Account Statement for the last 6 months (Salary account)</li>
                                <li>Brief statement of Assets & Liabilities of guardian/parent other co-borrower</li>
                            </ol>
                            <h5 className="about-head">Documentation Needed to Verify the Income of Self-employed Co-applicant/ Guarantor</h5>
                            <ol className="subhead-ul">
                                <li>Business Address Proof</li>
                                <li>TDS Certificate (Form 16A, if applicable)</li>
                                <li>Last 2 years IT returns (If IT Payee)</li>
                                <li>Brief Statement of Assets & Liabilities of guardian/parent/other co-borrower</li>
                                <li>Certificate of qualification (for C.A./ doctor and other professionals)</li>
                                <li>Bank Account Statement for the last 6 months</li>
                            </ol>
                            <h5 className="about-head">Necessary Documents for Availing of SBI Loan Against Property</h5>
                            <p className="loan-elegibility-des">The documents needed for collateral, for education loans from SBI vary based on different factors such as property type, purchase history, and location.</p>
                            <h6 className="subhead">Common Documents:</h6>
                            <ol className="subhead-ul">
                                <li>Registered sale deed.</li>
                                <li>Approved map or plan of the constructed property.</li>
                                <li>Chain documents, evidencing the ownership history of the property for the last 30 years. </li>
                                <li>Latest property tax receipt.</li>
                                <li>Occupancy proof.</li>
                            </ol>
                            <h5 className="about-head">Additional Documents Needed if you’re applying for an education loan from SBI with a property in the following cities:</h5>
                            <p className="loan-elegibility-des">The documents needed for collateral, for education loans from SBI vary based on different factors such as property type, purchase history, and location.</p>
                            <h6 className="subhead">Hyderabad</h6>
                            <ol className="subhead-ul">
                                <li>Urban land ceiling certificate</li>
                                <li>7/12 extract, if not included in the sale deed</li>
                                <li>NA certificate, if not included in the sale deed</li>
                                <li>Encumbrance certificate</li>
                            </ol>
                            <h6 className="subhead">Mumbai or Pune</h6>
                            <ol className="subhead-ul">
                                <li>NA order</li>
                                <li>NOC from a builder or society</li>
                                <li>Urban land ceiling order</li>
                                <li>Share certificate</li>
                                <li>Conveyance deed of society</li>
                                <li>Letter of allotment</li>
                                <li>If CIDCO / MHADA property: NOC and transfer letter</li>
                            </ol>
                            <h6 className="subhead">Bengaluru</h6>
                            <ol className="subhead-ul">
                                <li>Conversion order (from agriculture to residential)</li>
                                <li>RTC (Record of tenancy certificate)</li>
                                <li>Property tax receipt</li>
                                <li>Khata certificate (A or B)</li>
                                <li>Encumbrance certificate</li>
                            </ol>
                            <h5 className="about-head">Methods to Contact SBI Regarding an Education Loan</h5>
                            <p className="">There are several ways to get in touch with SBI for an education loan for studying abroad.</p>
                            <p className="loan-elegibility-des"><b>Email</b></p>
                            <p className="loan-elegibility-des">To contact SBI, you have the option of reaching out to them via email. Simply send an email to gm.customer@sbi.co.in, which is the address for SBI’s customer support team. Make sure to include all the necessary information about your profile so that they can provide you with a personalized response.</p>
                            <p className="loan-elegibility-des"><b>Online Application Form</b></p>
                            <p className="loan-elegibility-des">To apply, simply fill out the online application form on the SBI website (https://sbi.co.in/web/personal-banking/home). Afterward, SBI will review your information and take the required actions.</p>
                            <p className="loan-elegibility-des"><b>Branch Visits</b></p>
                            <p className="loan-elegibility-des">If you prefer a more personalized experience, you may choose to visit the nearest SBI branch in your city or area. The State Bank of India has an extensive network of 28,802 branches spread across all 36 states and union territories in India.
                                <br /><br />
                                If you find it inconvenient to visit branches and fill out complex application forms, Credere offers a more convenient approach to applying for an education loan. Credere is an education financing platform that specializes in assisting students in securing funds for their higher education abroad. By choosing our services, you can avoid the hassle of physical visits and dealing with complicated paperwork. Our dedicated counselors will thoroughly evaluate your profile and suggest the most suitable lenders that may meet your specific loan needs. </p>
                            <h5 classsName="about-head">How to Apply for an Education Loan from SBI via Credere?</h5>
                            <p className="loan-elegibility-des">Credere is an online platform that assists Indian students in funding their overseas education. We provide a hassle-free process for obtaining an education loan, consisting of just four simple steps.
                                <br /><br />
                                Apply online &gt;&gt; Free doorstep document collection &gt;&gt; Processing & approval &gt;&gt; Loan sanction & disbursal</p>
                            <h5 className="about-head">Advantages of Choosing Credere for your SBI Education Loan</h5>
                            <p className="loan-elegibility-des"><b>Quick Processing Time</b></p>
                            <p className="loan-elegibility-des">Credere collaborates with different departments in SBI to ensure loan approval within a short span of 15-20 days. This is the reason why thousands of students rely on us for their loan requests annually. If a student directly applies to the bank, the typical loan processing time by SBI is approximately 30-45 days.</p>


                            <p className="loan-elegibility-des"><b>Guaranteed Best Loan</b></p>
                            <p className="loan-elegibility-des">Our priority at Credere is to ensure that you receive the most competitive education loan available in the market. We are committed to bringing you the best possible offer. If you come across a better deal, we will cover the difference in interest rates for the entire duration of your education loan.</p>


                            <p className="loan-elegibility-des"><b>100% Free of Cost Services</b></p>
                            <p className="loan-elegibility-des">Credere offers completely free services to applicants. We do not ask for any processing fees or commissions from the applicants. </p>
                            <p className="loan-elegibility-des"><b>Doorstep Service</b></p>
                            <p className="loan-elegibility-des">Credere understands the importance of a smooth loan application process for students seeking education loans from SBI to study abroad. That’s why they offer a doorstep pickup service for required documents. Whether you’re in Delhi, Mumbai, Pune, Hyderabad, Bengaluru, Chennai, or Kolkata, you can rely on Credere to collect your documents right from your doorstep, saving you time and effort.</p>
                            <p className="loan-elegibility-des"><b>Higher Chances of Approval</b></p>
                            <p className="loan-elegibility-des">Whenever there are any missing documents, property concerns, or any other problems, we promptly approach the SBI officials to seek solutions. This ensures that any issues are resolved swiftly, increasing the likelihood of your approval. Remember, if you face any challenges, Credere will always be there to assist. </p>
                            <h5 className="about-head">Challenges in an SBI Education Loan</h5>
                            <p className="loan-elegibility-des">Here, we will now outline common obstacles that you need to be cautious of, as well as the strategies we employ to overcome these obstacles and accelerate the processing of your education loan application.</p>
                            <p className="loan-elegibility-des"><b>Branch Side</b></p>
                            <p className="loan-elegibility-des">Before the sanctioning process begins, it is necessary to submit all the required documents. There might be a need for additional documents as well. It is important to note that not all SBI branches are equally friendly when it comes to education loans. However, based on our wide experience in processing numerous education loans at SBI, we may assist you in finding the most helpful branch. We will communicate with the branch officials on your behalf and discuss your case with them. To simplify the process, we offer you with a personalized checklist at the beginning, ensuring that you only need to submit the documents once.</p>
                            <p className="loan-elegibility-des"><b>Legal Problems with The Property</b></p>
                            <p className="loan-elegibility-des">SBI-approved lawyers thoroughly examine both the legal documents of your property and the property itself. However, the time it takes for the bank and the lawyers to complete this process can be lengthy and uncertain. Moreover, there are instances where they may not put in sufficient effort to explore alternative documents or approaches when faced with issues related to the documents or the property. In such challenging circumstances, Credere has successfully assisted numerous students and we are confident that we can assist you too!</p>
                            <p className="loan-elegibility-des"><b>Technical Problems with The Property</b></p>
                            <p className="loan-elegibility-des">The SBI appoints Civil Engineers to assess properties. They start by visiting the property, measuring it, and examining its location and age. They also determine the Distress Sale Price, Fair Price, and Market Price of the property. However, the time it takes for the Civil Engineer to complete this evaluation can vary and be uncertain. Our objective is to complete this step within 3 working days by adhering to a systematic approach.</p>

                            <h5 className="about-head mt-4"> FAQ (Frequently Asked Questions) </h5>


                            {uniqueFeatures.map((item, idx) => (
                                <div className={`accordion-item${openIndex === idx ? ' open' : ''}`} key={idx}>
                                    <button className="accordion-title" onClick={() => handleAccordion(idx)}>
                                        {item.title}
                                        <span className="accordion-arrow">{openIndex === idx ? '-' : '+'}</span>
                                    </button>
                                    <div className="accordion-content" style={{ maxHeight: openIndex === idx ? '500px' : '0' }}>
                                        <p className="loan-eligibility-des mb-0">{item.content}</p>
                                        <p className="loan-eligibility-des mt-3"><b>{item.head}</b>{item.content1}</p>
                                        <p className="loan-eligibility-des"><b>{item.head1}</b>{item.content2}</p>
                                    </div>
                                </div>

                            ))}
                        </div>
                    </div>
                </div>
            </section >
        </>
    )
}

export default SbiLendingPartner;